import store from "./store";
import ajax from "./ajax";
import sdkconfig from "./sdkconfig";
import {setConfig} from "./sdk";
setConfig(sdkconfig);

function wrapURL(path) {
	if (/^https?:/.test(path)) return path;
	if (path[0] == "/") return path;
	if (!path.startsWith("v1/")) return process.env.API_DOMAIN + "/v1/" + path;
	return path;
}

let index = 1255;
function pushIndex(el) {
	el.style.zIndex = index++;
}

export {store, ajax, pushIndex, wrapURL};
